import SearchTrainTab from '@/containers/SearchTrainTab';
import { useTrackIdUpdateLink } from '@/utils/useTrackIdUpdateLink';
import BusIcon from '@mui/icons-material/DirectionsBus';
import FlightIcon from '@mui/icons-material/Flight';
import TrainIcon from '@mui/icons-material/Train';
import { styled } from '@mui/system';
import dynamic from 'next/dynamic';
import { useRef } from 'react';
import CustomTabs from '../Tabs';

const SearchFlightTab = dynamic(() => import('@/containers/SearchFlightTab'));
const SearchBusTab = dynamic(() => import('@/containers/Bus/SearchBusTab'));

const StyledWrapper = styled('div')({
  background: '#FFFFFF',
});

const HeaderTabs = ({ disableIcon, filterAirline, onClickTab }: { disableIcon?: boolean, filterAirline?: string[], onClickTab?: (newTab: string) => void }) => {
  const id = 'tim-chuyen';
  const ref = useRef(null) as any;
  useTrackIdUpdateLink(ref, id);

  return (
    <StyledWrapper
      id={id}
      ref={ref}
    >
      <CustomTabs
        onClickTab={onClickTab}
        labelObjs={[{
          type: 'flight',
          icon: disableIcon ? null : <FlightIcon />,
        }, {
          type: 'bus',
          icon: disableIcon ? null : <BusIcon />,
        }, {
          type: 'train',
          icon: disableIcon ? null : <TrainIcon />,
        }]}
        tabComponent={[
          <SearchFlightTab
            key="searchFlightTab"
            isCallFromHomepage
            filterAirline={filterAirline}
          />,
          <SearchBusTab
            isCallFromHomepage
            key={1}
          />,
          <SearchTrainTab key={2} />,
        ]}
      />
    </StyledWrapper>
  );
};

export default HeaderTabs;
